import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Star, Phone, Quote } from 'lucide-react';

const reviews = [
  { name: 'Jehan Day', text: 'They were the BEST to work with! Mario was extremely professional and the communication was outstanding! Would work with them again!' },
  { name: 'Hommy', text: 'We were very happy with our clean up process and would highly recommend. Punctual, creative and beyond hard working.' },
  { name: 'Travis Olson', text: 'Awesome response time and did the job fast! Kept in touch with me through the whole process. Super friendly too!' },
  { name: 'Nicole Medak', text: 'From start to finish the job was handled professionally. Estimate was accurate and there were no surprise additional costs.' },
  { name: 'James M', text: 'Responsive and friendly staff with great communication. They were respectful of my property and completed the job quickly.' },
  { name: 'Thomas Payne', text: 'Very fast, very professional, and super nice and friendly guys. I will recommend your services to anyone else I know.' },
  { name: 'Kevin Denton', text: 'Mario was great to work with. Professional, prompt with answers, and quick to get the job done. Highly recommend!' },
  { name: 'Laura Losing', text: 'Professional and kind service. Will definitely use Mario for all future junk removal services. Great experience overall.' },
  { name: 'David Jennings', text: 'Responsive, friendly, and affordable. Great communication throughout the entire process. Very satisfied with the service.' },
  { name: 'Matthew Sherwood', text: 'Impressed with their efficiency, professionalism, and commitment to sustainability. Strong community values and excellent service.' },
  { name: 'Trish Mengle', text: 'Mario is extremely professional, quick to respond, always on time, and very accommodating to scheduling needs.' },
  { name: 'Larry Jackson', text: 'Helpful, friendly, and did a wonderful job. Fair prices and honest service. Would recommend to anyone.' },
  { name: 'Taylor Howell', text: 'Very responsive, arrived early, completed the job quickly. Easy process and even charged less than originally quoted!' },
  { name: 'Hannah Cole', text: 'Highly recommend! They handled a remote property perfectly. Professional service from start to finish.' },
  { name: 'Shelley Parker', text: 'Good communication, dependable, does exactly what he says. Often comes in at the low end of the quote. Trustworthy service.' },
];

export default function ReviewsPage() {
  return (
    <div data-testid="reviews-page">
      {/* Hero with Gradient */}
      <section className="relative py-20 md:py-28 overflow-hidden" data-testid="reviews-hero">
        <div className="absolute inset-0 bg-gradient-to-br from-[#1a1a1a] via-[#2d2d2d] to-[#1a1a1a]" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_rgba(220,38,38,0.15)_0%,_transparent_50%)]" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,_rgba(220,38,38,0.1)_0%,_transparent_50%)]" />
        <div className="relative max-w-7xl mx-auto px-4 md:px-12 text-center">
          <div className="flex items-center justify-center gap-2 mb-6">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-10 h-10 fill-yellow-400 text-yellow-400" />
            ))}
          </div>
          <h1 className="font-['Barlow_Condensed'] text-5xl md:text-7xl font-bold text-white mb-4">
            Customer Reviews
          </h1>
          <p className="text-2xl text-gray-300">
            5 Stars on Google · 85 Reviews
          </p>
        </div>
      </section>

      {/* Reviews Grid */}
      <section className="py-20 md:py-32 bg-[#f5f5f5]">
        <div className="max-w-7xl mx-auto px-4 md:px-12">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {reviews.map((review, index) => (
              <div 
                key={index}
                className="bg-white p-8 rounded-2xl relative group hover:shadow-lg transition-shadow"
                data-testid={`review-${index}`}
              >
                <div className="absolute top-6 right-6 opacity-10 group-hover:opacity-20 transition-opacity">
                  <Quote className="w-16 h-16 text-[#dc2626]" />
                </div>
                <div className="relative z-10">
                  <div className="flex gap-1 mb-4">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                    ))}
                  </div>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    "{review.text}"
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-[#dc2626] rounded-full flex items-center justify-center text-white font-bold">
                      {review.name.charAt(0)}
                    </div>
                    <div>
                      <p className="font-semibold text-[#1a1a1a]">{review.name}</p>
                      <p className="text-sm text-gray-500">Google Review</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Google Reviews Link */}
          <div className="mt-16 text-center">
            <div className="inline-flex items-center gap-3 bg-white px-8 py-4 rounded-full shadow-sm">
              <img 
                src="https://www.gstatic.com/images/branding/product/1x/googleg_48dp.png" 
                alt="Google" 
                className="w-8 h-8"
              />
              <span className="text-gray-700">See all reviews on</span>
              <a 
                href="https://www.google.com/search?q=junk+removal+md+tahlequah"
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold text-[#dc2626] hover:underline"
                data-testid="google-reviews-link"
              >
                Google
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="py-20 md:py-28 bg-[#dc2626]" data-testid="reviews-cta">
        <div className="max-w-4xl mx-auto px-4 md:px-12 text-center">
          <h2 className="font-['Barlow_Condensed'] text-4xl md:text-5xl font-bold text-white mb-6">
            Want a 5-Star Junk Removal Team?
          </h2>
          <p className="text-white/90 text-lg mb-10">
            Join our satisfied customers and experience the Junk Removal M.D. difference.
          </p>
          <a href="tel:9183210654">
            <Button className="bg-white text-[#dc2626] hover:bg-gray-100 font-bold uppercase tracking-wider py-6 px-10 text-lg btn-press" data-testid="reviews-call-btn">
              <Phone className="w-5 h-5 mr-2" />
              Call Now
            </Button>
          </a>
        </div>
      </section>
    </div>
  );
}
